import React, {useCallback, useEffect, useState} from "react";
import ajaxloader from "../../images/ajax-loader.gif";
import CronConfigsList from "./CronConfigsList";
import superAdminService from "../../services/super.service";

export default function CronConfigs(props) {

    const [loadStatus, setLoadStatus] = useState("idle");
    const [loadMessage, setLoadMessage] = useState("");

    const [scans, setScans] = useState([]);

    const load = useCallback(() => {
        superAdminService.loadCronConfigs().then(
            response => {
                setScans(response.data["data"]);
                setLoadStatus("success");
            },
            error => {
                setLoadStatus("error");
                setLoadMessage("An error occurred while loading data");
            }
        );
    }, []);

    useEffect(() => {
        if (loadStatus === "idle") {
            setLoadStatus("pending");
            load();
        }
    }, [loadStatus, load]);

    if (loadStatus !== 'success') {
        return (
            <div className="main-content">
                <div style={{margin: "1rem auto"}}>
                    <img alt="loading" src={ajaxloader}/>
                </div>
            </div>
        )
    }

    if (!scans || scans.length === 0) {
        return (
            <div className="main-content">
                <div style={{margin: "1rem auto"}}>
                    <p>No data found</p>
                </div>
            </div>
        )
    }

    return (
        <div className="main-content">
            <span className={'client-title'}>Cron Configs</span>
            <p style={{marginTop: '20px'}}>
                Shows the existing cron configs
            </p>

            <CronConfigsList tgtDataOrig={scans} refreshFunc={() => load()}/>
        </div>
    );
}